import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const Privacy = () => {
  return (
    <>
      <SEO 
        title="Privacy Policy - ViralVoice AI"
        description="Privacy Policy and data handling practices for ViralVoice AI"
      />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white py-20">
        {/* Back to Home */}
        <Link 
          to="/" 
          className="fixed top-6 left-6 flex items-center gap-2 px-4 py-2 text-gray-400 hover:text-white transition-colors z-10"
        >
          <svg 
            className="w-5 h-5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M10 19l-7-7m0 0l7-7m-7 7h18" 
            />
          </svg>
          Back to Home
        </Link>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
            Privacy Policy
          </h1>
          
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Introduction</h2>
              <p>Last updated: {new Date().toLocaleDateString()}</p>
              <p className="mt-4">
                At ViralVoice AI, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Information We Collect</h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>Account information (name, email, profile picture)</li>
                <li>Voice samples for AI training</li>
                <li>Social media integration data</li>
                <li>Usage statistics and analytics</li>
                <li>Communication preferences</li>
              </ul>
            </section>

            {/* Add more sections as needed */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy; 